import styled from 'styled-components'

import { offWhite, darkBlue } from '../../../styles/settings/colors'

import { txt18OpenSans, txt14OpenSans } from '../../../styles/settings/types'

import content from '../../../styles/_objects/content'
import rem from '../../../styles/tools/rem'
import em from '../../../styles/tools/em'

import media from '../../../styles/tools/media'

export const Container = styled.section`
  background-color: ${offWhite};
  border-bottom: ${rem('1px')} solid rgba(197, 195, 216, 0.4);
  border-top: ${rem('1px')} solid rgba(197, 195, 216, 0.4);
  margin: 0 auto;
  padding: ${rem('23px')} 0 ${rem('51px')};

  ${media.small`
        padding: ${rem('32px')} ${rem('30px')} ${rem('6px')};
    `};
`

export const Content = styled.div`
  ${content};
`

export const AvatarContainer = styled.div`
  ${media.large`
        padding: 0 ${rem('11px')} 0;
    `};
`

export const AvatarList = styled.ul`
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  min-height: ${rem('76px')};
  padding: 0;
  width: 100%;

  ${media.small`
        display: block;

        :after {
            clear: both;
            content: '';
            display: table;
        }
    `};
`

export const ListItem = styled.li`
  ${media.small`
        float: left;
        margin-bottom: ${rem('24px')};
        text-align: center;
        width: 50%;
    `};
`

export const Title = styled.h2`
  ${txt18OpenSans} color: ${darkBlue};
  letter-spacing: ${em('-0.5px')};
  line-height: 1.33;
  margin: 0 0 ${rem('40px')};

  ${media.small`
        ${txt14OpenSans}
    `};
`



// WEBPACK FOOTER //
// ./src/app/modules/ChooseAvatar/styles.js